import { EXPERIMENT_TYPE } from '@fiverr-private/experiments_package';
import { MIRA_ENTRY_POINTS_V1 } from '../experiments/experimentsEnum';

export const clientExperiments = {
    /**
     * Pro search dropdown Mira card: A keeps the current Mira card, B-D render `MiraSearchBarCard` options.
     * Allocated when the card is shown (see `DynamicBrief`).
     */
    MIRA_ENTRY_POINTS_V1: {
        experimentId: MIRA_ENTRY_POINTS_V1,
        numOfGroups: 4,
        experimentType: EXPERIMENT_TYPE.USER,
        shouldAllocate: ({ userId }) => !!userId,
        getRolloutResult: (rollouts) => !!rollouts?.inPythonsMiraEntryPointsRollout,
    },
};
